/* eslint-disable no-useless-constructor */
import FieldModel from './FieldModel';
import { DateInput } from '../inputs';
import { isoDateToUTC } from '../../../../juristec-ui/utils/functions/lab';

class DateField extends FieldModel {
  /**
   * @param {Object} params
   * @param {string} params.kWord Unique object key (from plans)
   * @param {string} params.label Input label, used on the field filter
   * @param {boolean} [params.required] If the input is required (not empty)
   * @param {boolean} [params.removed] Condition to not render and use this field
   * @param {boolean} [params.disabled] Condition to block this field (still visible)
   * @param {any} [params.default] Default (initial) value
   * @param {function} [params.customValueCheck] Custom function to check the value
   * @param {boolean} [params.stateDependencyKey] If the state depends on another field's value
   */
  constructor(params) {
    super(params);
    this.trackDependencyValue = '';
    this.trackDependencyValueOld = '';
  }

  getDefaultState = () => ({
    value: this.default ?? '',
    formatedValue: this.default ? isoDateToUTC(this.default) : '',
    error: Boolean(this.required && this.default === undefined),
    errorMsg: this.required && this.default === undefined ? 'Informe uma data válida' : '',
  });

  genFormatedState = (value) => (value ? {
    value: value ? new Date(value) : null,
    formatedValue: value ? isoDateToUTC(new Date(value)) : '',
    error: false,
    errorMsg: '',
  } : this.getDefaultState());

  fieldComponent = (tempState, state, handle) => {
    this.trackDependencyValue = state[this.stateDependencyKey]?.value ?? '';
    if (this.trackDependencyValueOld !== this.trackDependencyValue) {
      const oldState = state[this.kWord] ?? this.getDefaultState();
      const err = Boolean(
        this.required && !oldState.value && this.boolCheck(this.customValueCheck, state),
      );
      if (err) {
        handle({
          [this.kWord]: {
            ...oldState,
            error: true,
            errorMsg: 'Informe uma data válida',
          },
        });
      } else {
        handle({
          [this.kWord]: {
            ...oldState,
            error: false,
            errorMsg: '',
          },
        });
      }
    }
    this.trackDependencyValueOld = this.trackDependencyValue;

    const prepHandle = (value) => {
      const error = Boolean(
        this.required && !value && this.boolCheck(this.customValueCheck, state),
      );
      handle({
        [this.kWord]: {
          value,
          formatedValue: value ? isoDateToUTC(value) : '',
          error,
          errorMsg: error ? 'Informe uma data válida' : '',
        },
      });
    };
    return (
      <DateInput
        label={this.label}
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
      />
    );
  };
}

export default DateField;
